import {TableContainer, TableHead, TableBody, TableCell, TableRow, Paper, Table, Grid, IconButton, CircularProgress} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {TAB_MISSING, TAB_YEAR_MISSING} from './StatsCommon.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getShortSpecName} from '../Trans.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';

const StatsYearMissing = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let pos;

	function statsYearMissingGetSpecName(spec_id) {
		const spec = gStorage.lists.speclist.list.find((x) => x.id === spec_id);

		return getShortSpecName(spec, gStorage.conn.user);
	}

	function copyToClipboard() {
		let cpText = '';

		gStorage.stats.obsList.forEach((item, i) => {
			if (i < 50) {
				if (cpText.length)
					cpText += ', ';

				cpText += statsYearMissingGetSpecName(item.taxon);
			}
		});

		navigator.clipboard.writeText(cpText);
	}

	function statsYearMissingRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('statsYearMissingRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('statsYearMissingRxWs: ' + msg.data.desc + '!');
			return;
		}

		// console.log('statsYearMissingRxWs', msg.data.yearmissing);

		if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_YEAR_MISSING)
			return;

		gStorage.stats.setObsList(msg.data.yearmissing);
	}

	function loadYearMissing() {
		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'year',
			op: 'missing',
			data: {
				country: gStorage.stats.country.id,
			}
		};

		// console.log('loadCityMissing', msg);
		gStorage.conn.ws.send(msg, statsYearMissingRxWs);
	}

	if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_YEAR_MISSING)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		loadYearMissing();

		return (
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<CircularProgress sx={{mt: 10}} />
			</Grid>
		);
	}

	pos = 0;

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							value: gStorage.stats.country,
							style: {width: 200}
						}}
					}
				/>
			</Grid>
			{gStorage.stats.obsList && 
				<TableContainer component={Paper} elevation={0} style={{width: 300, margin: 2}}>
					<Table size='small'>
						<TableHead>
							<TableRow>
								<TableCell padding='none'>#</TableCell>
								<TableCell>{t('stats._species')}</TableCell>
								<TableCell>
									<IconButton edge="start" color="inherit" onClick={copyToClipboard} aria-label="close">
										<ContentCopyIcon />
									</IconButton>
								</TableCell>
								<TableCell align='right'>{t('stats.score')}</TableCell>
							</TableRow>
						</TableHead>
						
						<TableBody>
							{gStorage.stats.obsList.map((elem, ind) => {
								if (elem.score <= 1) 
									return null;

								pos += 1;

								return (
									<TableRow key={ind}>
										<TableCell padding='none'>{pos}</TableCell>
										<TableCell colSpan={2}>{statsYearMissingGetSpecName(elem.taxon)}</TableCell>
										<TableCell align='right'>{elem.score}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			}
		</Grid>
	)
});

export default StatsYearMissing;
